import React from "react";
import "../css/Whybg.css"

function Whyusbg() {
  return ( 
      <div id="whybg" >
        <div class="d-flex align-items-center justify-content-center mt-5" style={{height: '100%'}}>
          <div class="text-whyusbg">
            <h1>
              <font>Jalan Hemat Kapan Saja dan Kemana Saja!</font>
            </h1>
            
          </div>
        </div>
     
    </div>
  );
}
   
export default Whyusbg;